<template>
  <div id="layout">
    <el-container>
      <el-aside class="no_print" style="width:auto">
        <div id="logo" class="dis-flex" style="align-items:center;justify-content: center;">
          <img class="mr5" width="50px" src="../assets/images/logo.png" />
          <span style="margin-left:-5px">
            工会资产档案信息系统 {{ env === "dev" ? "(测)" : "" }}
          </span>
        </div>

        <el-menu
          v-if="menuVisible"
          :default-active="currentPath"
          class="tal el-menu-vertical-demo noScroll"
          :style="{ height: clientHeight - 60 + 'px', width: '230px' }"
          style="border-right: none;overflow:auto;"
          background-color="#001529"
          text-color="#fff"
          active-text-color="#ffd04b"
          unique-opened
          :collapse="isCollapse"
          :router="true"
          @open="handleOpen"
          @close="handleClose">
          <template v-for="(o, i) in menuData">
            <div v-if="roleMenu.includes(String(o.id))" :key="i">
              <el-menu-item v-if="o.child.length === 0" :key="i" :index="o.url">
                <div class="menu_name">
                  <i :class="'ali-iconfont icon-' + o.icon"></i>
                  {{ o.menu_name }}
                </div>
              </el-menu-item>
              <!-- A: 非管理员账号且存在本级不允许显示资产管理栏
                    v-show="!(o.menu_name === '资产管理' && unitInfo.is_have_self === 1 && userInfo.id !== 0)" -->
              <!--B: 超级管理员切换为 A类型账号后，userInfo 依然为管理员，按理应显示资产管理栏，
                    而 A类型账号不应该显示资产管理栏，产生了冲突，为了使 超级管理员切换A类型账号 后与  A类型账号菜单显示一致（即隐藏资产管理栏），
                      利用 1：A类型账号 userInfo.unit_id = unitInfo.id ；2：超级管理员切换为 A类型账号 userInfo.unit_id != unitInfo.id
                        将 B 这种冲突进行 与 A区分 开来。
                      -->
              <el-submenu
                v-else
                v-show="
                  !(
                    o.menu_name === '资产管理' &&
                    unitInfo.is_have_self === 1 &&
                    (userInfo.id !== 0 ||
                      (userInfo.id === 0 && userInfo.unit_id != unitInfo.id))
                  ) && !(o.menu_name === '数据分析' && unitInfo.is_have_self === 0)
                "
                :index="String(i)"
              >
                <template slot="title">
                  <div class="menu_name">
                    <i :class="'ali-iconfont icon-' + o.icon"></i>
                    {{ o.menu_name }}
                  </div>
                </template>
                <!-- 对状况特殊处理 -->
                <!-- 1.单位性质页面 分类决定页面 -->
                <!-- 2.省总会不显示上报  无下级单位不显示审批 -->

                <el-menu-item
                  v-for="(o1, i1) in o.child"
                  :key="i1"
                  v-show="isShow(o1)"
                  :index="o1.url"
                >
                  <div class="menu_name ml4">
                    {{ o1.menu_name }}
                  </div>
                </el-menu-item>
              </el-submenu>
            </div>
          </template>
          <!-- 超级管理员角色为0 -->
          <el-submenu v-if="userInfo.role === 0" index="999">
            <template slot="title">
              <div class="menu_name">
                <i class="ali-iconfont icon-set"></i>
                超管权限
              </div>
            </template>
            <el-menu-item index="/system-journal">用户日志</el-menu-item>
            <el-menu-item index="/system-operation">操作集</el-menu-item>
            <el-menu-item index="/organization-guidetor">指南编辑</el-menu-item>
            <el-menu-item index="/organization-loglist">版本更新</el-menu-item>
            <el-menu-item v-show="env === 'dev'" index="/organization-edition">
              测试配置
            </el-menu-item>
          </el-submenu>
        </el-menu>
      </el-aside>
      <el-container>
        <el-header class="no-print" style="padding: 0 20px 0 0;">
          <div class="fl ml20" style="height:60px;display:flex;align-items:center;">
          </div>
          <div class="fl ml10" style="height:60px;display:flex;align-items:center;">
            <el-page-header class="hover" @back="goBack"></el-page-header>
            <el-breadcrumb separator="/">
              <el-breadcrumb-item>
                {{ this.$route.meta.routerName.parentName }}
              </el-breadcrumb-item>
              <el-breadcrumb-item v-if="this.$route.meta.routerName.childName">
                {{ this.$route.meta.routerName.childName }}
              </el-breadcrumb-item>
            </el-breadcrumb>
            <div class="ml20" v-show="currentPath === '/index' && indexPage === 'one'">
              <el-select
                style="width:120px"
                v-model="currentYear"
                size="small"
                @change="handleYearChange"
                placeholder="请选择">
                <el-option v-for="item in yearOp" :key="item" :label="item +'年'" :value="item"></el-option>
              </el-select>
            </div>
          </div>

          <div id="profile-dropdown">
            <el-dropdown @command="handleCommand">
              <div class="dis-flex" style="align-items:center;">
                <el-popover v-model="visible" placement="bottom-start" title="提示：" width="250" trigger="manual" content="">
                  <div style="text-align: right; margin: 0">
                    <span>
                      您有待审批事项，点击&nbsp;
                      <router-link to="/approval-approval">
                        <span @click="visible = false" style="font-size: 15px;color: red;">这里</span>
                      </router-link>
                      &nbsp; 查看
                    </span>
                    <el-button class="mt10" type="primary" size="mini" @click.native="visible = false">
                      知道了
                    </el-button>
                  </div>
                  <el-button style="pointer-events:none;color:#cccccc;" type="text" slot="reference">
                    <div style="display: flex;">
                      <i ref="waitApprovalButton" class="ali-iconfont icon-people ft20 mr3"></i>
                      <span style="color: #000;margin-top: 4px;">{{ wordSubstring(unitInfo.name) }}</span>
                    </div>
                  </el-button>
                </el-popover>
                <i class="el-icon-arrow-down el-icon--right"></i>
              </div>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item class="zdy" command="info">
                  <h4 style="color:#000">
                    {{ userInfo.name }}
                  </h4>
                  <span class="ft12 gray9 dropdownSpan">
                    {{ unitInfo.name}}
                  </span>
                </el-dropdown-item>
                <el-dropdown-item command="admin" divided>
                  <span>基本信息</span>
                </el-dropdown-item>
                <el-dropdown-item command="change-account" v-if="userInfo.role === 0 || (org.child && org.child.length)">
                  <span>
                    切换账户
                  </span>
                </el-dropdown-item>
                <el-dropdown-item command="logout">
                  <span>退出登录</span>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>

          <div class="header-search mr10">
            <!-- 省总工会以及市总工会均有BI -->
            <router-link
              v-show="unitInfo.id === 1 || (unitInfo.name.endsWith('市总工会'))"
              :to="'/bi?id=' + unitInfo.id + '&name=' + unitInfo.name"
              target="_blank"
              class="mr15 biClass"
              tag="a">
              <i class="iconfontEqual icon-diannao-shuju ft19"></i>
              工会资产看板
            </router-link >

            <router-link
              to="/organization-updatelog"
              class="mr15 biClass"
              tag="a">
              <i class="iconfontEqual icon-daily ft19"></i>
              更新日志
            </router-link>
            <!-- 您好 -->
            <div>
              <el-input
                placeholder="单位档案、报表、材料"
                @keyup.enter.native="handleSearch"
                size="small"
                v-model="searchVal">
                <i
                  style="margin-top: 24px;cursor: pointer"
                  @click="handleSearch"
                  slot="suffix"
                  class="el-icon-search">
                </i>
              </el-input>
            </div>
          </div>
        </el-header>

        <el-main class="content-height">
          <keep-alive :include="['Query']">
            <router-view />
          </keep-alive>
        </el-main>
      </el-container>
    </el-container>

    <!-- 待审批提示的背景板 -->
    <div
      v-if="visible"
      style="
        position: fixed;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 2001;
        top: 0;
        width: 100%;
        height: 100%;
        opacity: .5;
        background: #000;
      ">
    </div>

    <el-dialog width="640px" :visible.sync="changeAccountDialogVisible" title="切换单位选择">
        <el-select
          placeholder="请选择（可输入搜索）"
          class="mb10"
          filterable
          style="width: 100%"
          v-model="selectedChangeEdUnitId">
          <el-option
            v-for="item in allOrgId"
            :key="item.value"
            :value="item.value"
            :label="item.label"
          />
        </el-select>
        <div slot="footer">
          <el-button @click="changeAccountDialogVisible = false">取消</el-button>
          <el-button @click="changeAccount" type="primary">确定</el-button>
        </div>
    </el-dialog>

    <el-dialog width="640px" :visible.sync="updateVisible">
      <h2 style="color:#38a0f4;display:inline-block;margin-top:-10px;font-weight:500;font-size:27px">版本更新通知</h2>
      <el-button type="warning" round size="mini" style="background:#fca810;font-size:17px;height:27px;display:inline-block;margin-left:10px;border:1px solid transparent">
       <div class="Version" style="margin-left:-5px;margin-right:-5px">
         {{noticeData.version}}
       </div>
      </el-button>
      <div class="content" style="margin-top:15px">
        <p><pre style="white-space: pre-wrap;">{{noticeData.details}}</pre></p>
      </div>
      <div style="margin-top:20px">
      <el-button @click="updateNow" size="large" type="primary" class="buttonOne" style="margin-top:20px;font-size:17px;color:#fff" round>立即更新</el-button>
      <el-button
        @click="viewDetails"
        size="large"
        style="color:#38a0f4;font-size:17px"
        round
        class="buttonTwo"
        >查看详情</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { MessageBox } from "element-ui";
import store from "../store";
import {mapState } from 'vuex'
export default {
  name: "layout",
  data() {
    return {
      version:'',
      details:'',
      update_time:'',
      id:'',
      noticeData:[],
      updateVisible:false,
      allOrgId: [],
      changeAccountDialogVisible: false,
      selectedChangeEdUnitId: undefined,
      visible: false,
      waitApprovalNumber: 0, // 待审批记录数量
      env: "",
      formLabelWidth: "120px",
      currentTime: "", // 当前时间
      timeOut: 1800000, // 过期时间 半小时
      searchVal: "",
      isCollapse: false,
      currentYear: "",
      indexPage: "",
      activeIndex: "/home",
      name: "",
      menuVisible: true,
      currentPath: "",
      menuDataCache: [],
      menuData: [],
    };
  },
  computed:{
    ...mapState({
      yearOp: (state) => state.yearOp
    })
  },
  watch: {
    $route: {
      handler: function(val) {
        this.currentPath = val.path;
      },
      immediate: true,
      // 深度观察监听
      deep: true
    }
  },
  created() {
    this.getFirstNotice();
    this.currentYear = this.globalYear;
    this.$api
      .getMenu({
        params: {
          user_id: 0
        }
      })
      .then(res => {
        this.menuData = res.data;
        this.menuDataCache = res.data;
      });

    this.env = process.env.VUE_APP_env;
  },
  mounted() {
    this.handleOverdue();
    // 获取待审批记录数量,同时要判断页面是否刷新，刷新则不显示
    if (window.name == "") {
      this.$api
        .getshangbaoNumber({
          params: {
            unit_id: this.unitInfo.id,
            report_or_approval: "审批"
          }
        })
        .then(res => {
          this.waitApprovalNumber = res.data.wait;
          // 具有审批权限并待审批记录数量大于零
          if (
            this.waitApprovalNumber > 0 &&
            this.permission["17"].indexOf("366") !== -1
          ) {
            this.visible = true;
            this.$refs["waitApprovalButton"].click();
          }
        });
      // console.log("首次被加载");
      window.name = "isReload"; // 在首次进入页面时我们可以给window.name设置一个固定值
    } else if (window.name == "isReload") {
      // console.log("页面被刷新");
    }
  },
  methods: {
    wordSubstring(val) {
      if(val.length > 10) {
        return val.substring(0, 9) + '...'
      } else {
        return val
      }
    },
    getFirstNotice(){
      this.$api
      .firstNotice({
        params:{
          user_id:this.userInfo.id,
        }
      })
      .then( res => {
         if(res.data.length > 0){
            const data = res.data[0]
            this.$api
              .updateLog({
                id:data.id,
                version:data.version,
                details:data.details,
                update_time: data.update_time,
                status:data.status,
                create_user:data.create_user,
              })
              .then(res =>{
                this.noticeData = res.data
                this.$nextTick(() => {
                  //渲染完毕后执行
                  this.updateVisible = true
                })
              })
          }else{
            this.updateVisible=false
          }
        })
    },
    updateNow(){
      //强制刷新
      this.$router.go(0)
    },
    viewDetails(){
      this.updateVisible=false,
      this.$router.push({ path:"/organization-updatelog"})
    },
    handleYearChange(val) {
      this.$store.commit("SET_GLOBAL_YEAR", val);
    },
    isShow(o1) {
      let a =
        !(this.unitInfo.id === 1 && o1.url === "/approval-report") &&
        !(this.unitInfo.is_have_child === 0 && o1.url === "/approval-approval");
      let b =
        (this.roleMenu.includes(String(o1.id)) &&
          (o1.url !== "/assets-service" ||
            (o1.url === "/assets-service" &&
              [
                22,
                23,
                27,
                30,
                31,
                32,
                38,
                43,
                29,
                37,
                25,
                34,
                26,
                35,
                24,
                28,
                36,
                45
              ].includes(this.unitInfo["category_type"])))) ||
        (this.userInfo.role === 0 &&
          (o1.url !== "/organization-properties" ||
            o1.url !== "/system-menu" ||
            o1.url !== "/system-menu-permission"));
      return a && b;
    },
    goBack() {
      this.$router.go(-1);
    },
    // 获取江西全省的组织单位
    getAllOrg() {
      let options = [];
      function a(array) {
        array.forEach(o => {
          // 筛除禁用状态的下属单位
          if(o.status !== 2) {
            options.push({
            value: o.id,
            label: o.name
          });
          }
          if (o.child) {
            a(o.child);
          }
        });
        return options;
      }
      return new Promise((resolve) => {
        this.$api .getOrg({
          params: {
            org_id: this.userInfo.unit_id
          }
        }).then(res => {
            if (res.error_no == 0) {
              this.allOrgId = [];
              let array = [];
              array.push(res.data);
              this.allOrgId = a(array);
              resolve();
            }
        })
      })
    },
    handleSearch() {
      let _self = this;
      if (!_self.searchVal) {
        _self.$notify({
          title: "温馨提示",
          message: "搜索内容不能为空",
          type: "warning",
          position: "bottom-right"
        });
        return false;
      } else {
        _self.$router.push({
          path: "statistics-query",
          query: { content: _self.searchVal }
        });
        _self.searchVal = "";
      }
    },
    handleCommand(command) {
      if (command === "admin") {
        if(this.$route.path != '/organization-userinfo') {
          this.$router.push("/organization-userinfo");
        }
      } else if (command === "logout") {
        document.removeEventListener("mouseover", this.over);
        this.handleLogout();
      } else if (command === "change-account") {
        this.changeAccountFnc();
      }
    },
    changeAccountFnc() {
      // 获取供选择的单位数据
      this.getAllOrg().then(() => {
        this.changeAccountDialogVisible = true;
      });
    },
    async changeAccount() {
      // 切换单位-更新 state 中 ， 参数需要 unit_id，同时赋值给 a
      let a = await this.$store.dispatch(
        "changeUnitInfo",
        this.selectedChangeEdUnitId
      );
      if(typeof a === "string" || a.father_property_type === null) {
        this.$notify({
          title: "提示：",
          message: "该单位信息查询失败或者单位信息未完善导致无法切换，请核实",
          position: "bottom-right",
          type: "error"
        });
        this.changeAccountDialogVisible = false;
        return false;
      }
      this.$store.dispatch( "getAllOrg", {
        params: {
          org_id: this.unitInfo.id
        }
      });
      // 重新生成 el-menu 组件，避免导航栏高亮错误
      this.menuVisible = false;
      this.menuData = [];
      // 切换单位-更新 state 中 menu
      let b = await store.dispatch("getCoType");
      if (a.father_property_type === -1) {
        store.commit("SET_MENU", b[3].menu_ids);
      } else {
        let c = b.find(o => {
          // console.log("菜单");
          return o.id === a.father_property_type;
        });
        let d = c.child.find(o => {
          return o.id === a["property_type"];
        });
        store.commit("SET_MENU", d.menu_ids);
      }
      let _self = this;
      // 菜单遍历的主体为 this.menuData ,遍历条件为 this.roleMenu
      // 仅仅更新 this.roleMenu 情况下，el-submenu 下的子菜单无法更新，故根据变化后的 this.roleMenu 更新 this.menuData 以动态更新 el-menu
      /* eslint-disable */
      function setMenu(array) {
        let menu = [];
        for (let i in array) {
          if (_self.roleMenu.includes(String(array[i].id))) {
            let node = array[i];
            if (array[i].child) {
              node.child = setMenu(array[i].child);
            }
            menu.push(node);
          }
        }
        return menu;
      }
      // setMenu 函数会改变 this.menuDataCache 的值，所以深度拷贝一份
      /* eslint-enable */
      this.menuData = setMenu( JSON.parse(JSON.stringify(this.menuDataCache)));
      // 切换单位-更新资产管理监督部门
      await this.$store.dispatch("getUnitAssetsInfo");
      if (this.$route.path != "/index") {
        this.$router.push("/index");
      }
      this.changeAccountDialogVisible = false;
      this.menuVisible = true;
    },
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
    handleLogout() {
      window.name = "";
      this.$store.commit("RESET_STATE");
      localStorage.clear();
      this.$router.replace("/login");
    },
    over() {
      let _self = this;
      let n = new Date().getTime();
      let currentTime = Number(localStorage.getItem("currentTime"));
      if (currentTime && n - currentTime > _self.timeOut) {
        document.removeEventListener("mouseover", _self.over);
        MessageBox.alert("登录状态已过期，请重新登录", "提示", {
          confirmButtonText: "确定",
          center: true,
          showClose: false
        }).then(() => {
          _self.handleLogout();
        });
      } else {
        localStorage.setItem("currentTime", n);
      }
    },
    handleOverdue() {
      let _self = this;
      let now = new Date().getTime();
      let old = localStorage.getItem("currentTime");
      if (old && now - old > _self.timeOut) {
        MessageBox.alert("登录状态已过期，请重新登录", "提示", {
          confirmButtonText: "确定",
          center: true,
          showClose: false
        }).then(() => {
          _self.handleLogout();
        });
        return false;
      } else {
        localStorage.setItem("currentTime", now);
      }
      document.addEventListener("mouseover", _self.over);
    }
  }
};
</script>

<style lang="stylus" scoped>
.content p{
  word-break: break-all;
  word-wrap: break-word;
  text-align: left;
  display: inline-block;//使P的宽度根据文字的宽度伸缩
}//左对齐
.buttonTwo{
  width:150px;
  border:1px solid #38a0f4;
}
/deep/.el-dialog{
  border-radius:10px
  // 圆角
}
.Version{
  // margin-top:-4px
  position: relative;
  top: 50%;
  transform: translateY(-50%);
}
.buttonOne
  width:150px
.biClass{
  color:#409EFF;
  cursor pointer
}
img {
  margin-right: 10px;
}

#layout {
  min-height: 100vh;
  overflow-x: hidden;
}

#logo {
  height: 60px;
  background-color: #001529;
  color: #ffffff;
  text-align: center;
  line-height: 60px;
  font-size: 14px;
  font-weight: bold;
}

#profile-dropdown {
  text-align: right;
  // width: 300px;
  float: right;
  height: 60px;
  line-height: 60px;
  cursor: pointer;
}

.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 200px;
  min-height: 400px;
}

.bgColor {
  background: #fff !important;
}

.header-search {
  display: flex;
  height: 60px;
  line-height: 60px;
  float: right;
  border-radius: 25px;
  align-items: center;
  input {
    border-radius: 25px !important;
  }
}

.icon-search {
  cursor: pointer;
}
</style>
